module.exports = __webpack_public_path__ + "img/virtual_kit.9cdd9cf2.png";